<template>
  <div>
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('attrSpecManage.queryCondition') }}</span>
        <div>
          <el-button type="text" @click="_moreCondition()">
            {{ attrSpecManageInfo.moreCondition ? $t('attrSpecManage.hide') : $t('attrSpecManage.more') }}
          </el-button>
        </div>
      </div>
      <el-form :inline="true" :model="attrSpecManageInfo.conditions" class="flex justify-start">
        <el-form-item>
          <el-form-item>
            <el-input v-model="attrSpecManageInfo.conditions.specName"
              :placeholder="$t('attrSpecManage.specNamePlaceholder')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="attrSpecManageInfo.conditions.tableName"
              :placeholder="$t('attrSpecManage.tableNamePlaceholder')" style="width:100%">
              <el-option v-for="item in tableOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="attrSpecManageInfo.conditions.specCd" :placeholder="$t('attrSpecManage.specPlaceholder')"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="attrSpecManageInfo.conditions.domain"
              :placeholder="$t('attrSpecManage.domainPlaceholder')" clearable></el-input>

          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryAttrSpecMethod()">
              <i class="el-icon-search"></i>
              {{ $t('attrSpecManage.query') }}
            </el-button>
            <el-button @click="_resetAttrSpecMethod()">
              <i class="el-icon-refresh"></i>
              {{ $t('attrSpecManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form-item>

      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('attrSpecManage.attrConfig') }}</span>
        <div>
          <el-button type="primary" size="small" @click="_openAddAttrSpecModal()">
            <i class="el-icon-plus"></i>
            {{ $t('attrSpecManage.add') }}
          </el-button>
        </div>
      </div>
      <el-table :data="attrSpecManageInfo.attrSpecs" border style="width: 100%">
        <el-table-column prop="domain" :label="$t('attrSpecManage.domain')" align="center"></el-table-column>
        <el-table-column prop="specName" :label="$t('attrSpecManage.specName')" align="center"></el-table-column>
        <el-table-column prop="specCd" :label="$t('attrSpecManage.spec')" align="center"></el-table-column>
        <el-table-column prop="tableName" :label="$t('attrSpecManage.attrTable')" align="center">
          <template slot-scope="scope">
            {{ getTableName(scope.row.tableName) }}
          </template>
        </el-table-column>
        <el-table-column prop="required" :label="$t('attrSpecManage.required')" align="center">
          <template slot-scope="scope">
            {{ scope.row.required === 'Y' ? $t('attrSpecManage.yes') : $t('attrSpecManage.no') }}
          </template>
        </el-table-column>
        <el-table-column prop="specShow" :label="$t('attrSpecManage.show')" align="center">
          <template slot-scope="scope">
            {{ scope.row.specShow === 'Y' ? $t('attrSpecManage.yes') : $t('attrSpecManage.no') }}
          </template>
        </el-table-column>
        <el-table-column prop="specValueType" :label="$t('attrSpecManage.valueType')" align="center">
          <template slot-scope="scope">
            {{ _getSpecValueTypeName(scope.row.specValueType) }}
          </template>
        </el-table-column>
        <el-table-column prop="specType" :label="$t('attrSpecManage.specType')" align="center">
          <template slot-scope="scope">
            {{ _getSpecTypeName(scope.row.specType) }}
          </template>
        </el-table-column>
        <el-table-column prop="listShow" :label="$t('attrSpecManage.queryShow')" align="center">
          <template slot-scope="scope">
            {{ scope.row.listShow === 'Y' ? $t('attrSpecManage.yes') : $t('attrSpecManage.no') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('attrSpecManage.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_openAttrSpecValue(scope.row)">
                {{ $t('attrSpecManage.discreteValue') }}
              </el-button>
              <el-button size="mini" type="primary" @click="_openEditAttrSpecModel(scope.row)">
                {{ $t('attrSpecManage.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteAttrSpecModel(scope.row)">
                {{ $t('attrSpecManage.delete') }}
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="attrSpecManageInfo.conditions.page"
        :page-size="attrSpecManageInfo.conditions.row" layout="total, prev, pager, next"
        :total="attrSpecManageInfo.total" style="margin-top: 20px; text-align: right;"></el-pagination>
    </el-card>

    <add-attr-spec ref="addAttrSpec" @success="queryAttrSpec"></add-attr-spec>
    <edit-attr-spec ref="editAttrSpec" @success="queryAttrSpec"></edit-attr-spec>
    <delete-attr-spec ref="deleteAttrSpec" @success="queryAttrSpec"></delete-attr-spec>
  </div>
</template>

<script>
import { listAttrSpec } from '@/api/dev/attrSpecApi'
import AddAttrSpec from '@/components/dev/addAttrSpec/addAttrSpec'
import EditAttrSpec from '@/components/dev/editAttrSpec/editAttrSpec'
import DeleteAttrSpec from '@/components/dev/deleteAttrSpec/deleteAttrSpec'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AttrSpecManage',
  components: {
    AddAttrSpec,
    EditAttrSpec,
    DeleteAttrSpec
  },
  data() {
    return {
      attrSpecManageInfo: {
        attrSpecs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          page: 1,
          row: 10,
          specName: '',
          tableName: '',
          specCd: '',
          domain: ''
        }
      },
      tableOptions: [
        { value: 'building_room_attr', label: this.$t('attrSpecManage.buildingRoomAttr') },
        { value: 'building_owner_attr', label: this.$t('attrSpecManage.buildingOwnerAttr') },
        { value: 'building_community_attr', label: this.$t('attrSpecManage.buildingCommunityAttr') },
        { value: 'machine_attr', label: this.$t('attrSpecManage.machineAttr') },
        { value: 'parking_area_attr', label: this.$t('attrSpecManage.parkingAreaAttr') },
        { value: 'owner_car_attr', label: this.$t('attrSpecManage.ownerCarAttr') }
      ]
    }
  },
  created() {
    this._listAttrSpecs(1, 10)
  },
  methods: {
    queryAttrSpec() {
      this._listAttrSpecs(1, 10)
    },
    _listAttrSpecs(page, rows) {
      this.attrSpecManageInfo.conditions.page = page
      this.attrSpecManageInfo.conditions.row = rows
      const params = {
        ...this.attrSpecManageInfo.conditions,
        shopId: getShopId()
      }

      listAttrSpec(params).then(res => {
        this.attrSpecManageInfo.total = res.total
        this.attrSpecManageInfo.records = res.records
        this.attrSpecManageInfo.attrSpecs = res.data
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    _openAddAttrSpecModal() {
      this.$refs.addAttrSpec.open()
    },
    _openEditAttrSpecModel(attrSpec) {
      this.$refs.editAttrSpec.open(attrSpec)
    },
    _openDeleteAttrSpecModel(attrSpec) {
      this.$refs.deleteAttrSpec.open(attrSpec)
    },
    _queryAttrSpecMethod() {
      this._listAttrSpecs(1, 10)
    },
    _resetAttrSpecMethod() {
      this.attrSpecManageInfo.conditions = {
        page: 1,
        row: 10,
        specName: '',
        tableName: '',
        specCd: '',
        domain: ''
      }
      this._listAttrSpecs(1, 10)
    },
    _moreCondition() {
      this.attrSpecManageInfo.moreCondition = !this.attrSpecManageInfo.moreCondition
    },
    _getSpecValueTypeName(specValueType) {
      const types = {
        '1001': this.$t('attrSpecManage.string'),
        '2002': this.$t('attrSpecManage.integer'),
        '3003': this.$t('attrSpecManage.amount'),
        '4004': this.$t('attrSpecManage.date'),
        '5005': this.$t('attrSpecManage.time')
      }
      return types[specValueType] || this.$t('attrSpecManage.unknown')
    },
    _getSpecTypeName(specValue) {
      const types = {
        '2233': 'input',
        '3344': 'select',
        '4455': this.$t('attrSpecManage.date')
      }
      return types[specValue] || this.$t('attrSpecManage.unknown')
    },
    getTableName(tableName) {
      const tableNames = {
        'building_room_attr': this.$t('attrSpecManage.buildingRoomAttr'),
        'building_owner_attr': this.$t('attrSpecManage.buildingOwnerAttr'),
        'building_community_attr': this.$t('attrSpecManage.buildingCommunityAttr'),
        'machine_attr': this.$t('attrSpecManage.machineAttr'),
        'parking_area_attr': this.$t('attrSpecManage.parkingAreaAttr'),
        'owner_car_attr': this.$t('attrSpecManage.ownerCarAttr')
      }
      return tableNames[tableName] || this.$t('attrSpecManage.unknown')
    },
    _openAttrSpecValue(attrSpec) {
      this.$router.push({
        path: '/pages/dev/attrValueManage',
        query: {
          specId: attrSpec.specId,
          specName: attrSpec.specName,
          domain: attrSpec.domain
        }
      })
    },
    handleCurrentChange(val) {
      this._listAttrSpecs(val, this.attrSpecManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>